var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16310",
    "data-name": "Group 16310",
    transform: "translate(-1536 -143.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3422",
    "data-name": "Rectangle 3422",
    width: 30,
    height: 30,
    transform: "translate(1536 143.507)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16311",
    "data-name": "Group 16311",
    transform: "translate(1539.026 146.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11444",
    "data-name": "Path 11444",
    d: "M58.485,2.3s0,0,0-.008a.38.38,0,0,0-.017-.1c0-.007,0-.014-.006-.021a.381.381,0,0,0-.048-.092L58.4,2.065a.384.384,0,0,0-.072-.071l-.006-.006L56.428.639a3.432,3.432,0,0,0-2-.639h-8.37a3.433,3.433,0,0,0-2,.639l-1.9,1.349-.006.006a.384.384,0,0,0-.072.071l-.011.013a.381.381,0,0,0-.048.092c0,.007,0,.014-.006.021a.38.38,0,0,0-.017.1s0,0,0,.008V7.219a6.792,6.792,0,0,1,.767.291V2.684H57.718V21.852H54.46v.767h3.259v1.15H53.693V18.785a3.45,3.45,0,0,0-6.9,0v4.984H42.767v-1.15h3.259v-.767h-3.1l-.154.3h0l-.218.421-.023.044L42,23.629v.14a.768.768,0,0,0,.767.767H57.718a.768.768,0,0,0,.767-.767V2.3Zm-14.9-.381.918-.653a2.67,2.67,0,0,1,1.556-.5h8.37a2.67,2.67,0,0,1,1.556.5l.918.653Zm9.343,21.852H47.559V18.785a2.684,2.684,0,0,1,5.367,0Z",
    transform: "translate(-33.97 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11445",
    "data-name": "Path 11445",
    d: "M105.383,22.684H107.3a.383.383,0,0,0,.383-.383V20.383A.383.383,0,0,0,107.3,20h-1.917a.383.383,0,0,0-.383.383V22.3a.383.383,0,0,0,.383.383Zm.383-1.917h1.15v1.15h-1.15Z",
    transform: "translate(-84.893 -16.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11446",
    "data-name": "Path 11446",
    d: "M105,42.3a.383.383,0,0,0,.383.383H107.3a.383.383,0,0,0,.383-.383V40.383A.383.383,0,0,0,107.3,40h-1.917a.383.383,0,0,0-.383.383Zm.767-1.534h1.15v1.15h-1.15Z",
    transform: "translate(-84.893 -32.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11447",
    "data-name": "Path 11447",
    d: "M105,62.3a.383.383,0,0,0,.383.383H107.3a.383.383,0,0,0,.383-.383V60.383A.383.383,0,0,0,107.3,60h-1.917a.383.383,0,0,0-.383.383Zm.767-1.534h1.15v1.15h-1.15Z",
    transform: "translate(-84.893 -48.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11448",
    "data-name": "Path 11448",
    d: "M87.383,22.684H89.3a.383.383,0,0,0,.383-.383V20.383A.383.383,0,0,0,89.3,20H87.383a.383.383,0,0,0-.383.383V22.3a.383.383,0,0,0,.383.383Zm.383-1.917h1.15v1.15h-1.15Z",
    transform: "translate(-70.344 -16.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11449",
    "data-name": "Path 11449",
    d: "M87,42.3a.383.383,0,0,0,.383.383H89.3a.383.383,0,0,0,.383-.383V40.383A.383.383,0,0,0,89.3,40H87.383a.383.383,0,0,0-.383.383Zm.767-1.534h1.15v1.15h-1.15Z",
    transform: "translate(-70.344 -32.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11450",
    "data-name": "Path 11450",
    d: "M87,62.3a.383.383,0,0,0,.383.383H89.3a.383.383,0,0,0,.383-.383V60.383A.383.383,0,0,0,89.3,60H87.383a.383.383,0,0,0-.383.383Zm.767-1.534h1.15v1.15h-1.15Z",
    transform: "translate(-70.344 -48.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11451",
    "data-name": "Path 11451",
    d: "M69.383,22.684H71.3a.383.383,0,0,0,.383-.383V20.383A.383.383,0,0,0,71.3,20H69.383a.383.383,0,0,0-.383.383V22.3a.383.383,0,0,0,.383.383Zm.383-1.917h1.15v1.15h-1.15Z",
    transform: "translate(-55.794 -16.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11452",
    "data-name": "Path 11452",
    d: "M69,42.3a.383.383,0,0,0,.383.383H71.3a.383.383,0,0,0,.383-.383V40.383A.383.383,0,0,0,71.3,40H69.383a.383.383,0,0,0-.383.383Zm.767-1.534h1.15v1.15h-1.15Z",
    transform: "translate(-55.794 -32.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11453",
    "data-name": "Path 11453",
    d: "M69,62.3a.383.383,0,0,0,.383.383H71.3a.383.383,0,0,0,.383-.383V60.383A.383.383,0,0,0,71.3,60H69.383a.383.383,0,0,0-.383.383Zm.767-1.534h1.15v1.15h-1.15Z",
    transform: "translate(-55.794 -48.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11454",
    "data-name": "Path 11454",
    d: "M53.684,20.383A.383.383,0,0,0,53.3,20H51.383a.383.383,0,0,0-.383.383V22.3a.383.383,0,0,0,.383.383H53.3a.383.383,0,0,0,.383-.383Zm-.767,1.534h-1.15v-1.15h1.15Z",
    transform: "translate(-41.244 -16.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11455",
    "data-name": "Path 11455",
    d: "M52.631,41.917c.12.162.236.328.342.5.053.087.1.176.149.264H53.3a.383.383,0,0,0,.383-.383V40.383A.383.383,0,0,0,53.3,40H51.388a.383.383,0,0,0-.382.373,6.548,6.548,0,0,1,.766.6v-.2h1.15v1.15Z",
    transform: "translate(-41.249 -32.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11456",
    "data-name": "Path 11456",
    d: "M11.07,42.815A5.945,5.945,0,0,0,5.922,40,5.945,5.945,0,0,0,.774,42.815a5.265,5.265,0,0,0-.182,5.263L4.8,56.2a1.275,1.275,0,0,0,2.239,0l4.21-8.122A5.265,5.265,0,0,0,11.07,42.815Zm-.5,4.91-4.21,8.122a.509.509,0,0,1-.878,0l-4.21-8.122a4.513,4.513,0,0,1,.156-4.512,5.184,5.184,0,0,1,4.493-2.449,5.184,5.184,0,0,1,4.493,2.449,4.513,4.513,0,0,1,.156,4.512Z",
    transform: "translate(0 -32.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11457",
    "data-name": "Path 11457",
    d: "M16.45,52a3.45,3.45,0,1,0,3.45,3.45A3.45,3.45,0,0,0,16.45,52Zm0,6.134a2.684,2.684,0,1,1,2.684-2.684,2.684,2.684,0,0,1-2.684,2.684Z",
    transform: "translate(-10.528 -42.032)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkLocation);
export default __webpack_public_path__ + "static/media/workLocation.a2717b0d3aff802dadcc6633aa978bce.svg";
export { ForwardRef as ReactComponent };